/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PaintRollerIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="paint-roller"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M3.5 6C3.5 4.619 4.619 3.5 6 3.5L14 3.5C15.381 3.5 16.5 4.619 16.5 6C16.5 7.381 15.381 8.5 14 8.5L6 8.5C4.619 8.5 3.5 7.381 3.5 6Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16.5 6L18.5 6C19.605 6 20.5 6.895 20.5 8L20.5 9C20.5 10.105 19.605 11 18.5 11L12 11C10.895 11 10 11.895 10 13L10 14" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8 16C8 14.895 8.895 14 10 14C11.105 14 12 14.895 12 16L12 18.5C12 19.605 11.105 20.5 10 20.5C8.895 20.5 8 19.605 8 18.5L8 16Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
